module.exports = __webpack_public_path__ + "static/img/8d.ad965bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/8d.jpg
// module id = xgW4
// module chunks = 1